export default "__VITE_ASSET__05e85d3a__"